import React from 'react';
import { TouchableOpacity } from 'react-native';

import { Box } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import Text from '@components/Text/Text';
import { useHover } from '@hooks/useHover';
import Images from '@themes/images';
import { getStructuralRowBackground } from '@utils/hoverStyles';

type PopupStatusItemProps = {
  title: string;
  icon: keyof typeof Images;
  width: number;
  onPress: () => void;
};

/**
 * Menu item row shared by the status dropdowns (projects / subscriptions).
 * Dropdown menu item (TA-9005): structural surface, hover tints to grey01.
 */
export const PopupStatusItem = ({
  title,
  icon,
  width,
  onPress,
}: PopupStatusItemProps) => {
  const { isHovered, hoverProps } = useHover();
  const backgroundColor = getStructuralRowBackground(isHovered);
  return (
    <TouchableOpacity onPress={onPress} accessibilityLabel={title}>
      <Box
        {...hoverProps}
        flexDirection='row'
        alignItems='center'
        justifyContent='flex-start'
        backgroundColor={backgroundColor}
        style={{ height: 32, width }}>
        <Icon
          variant='s'
          marginLeft='xs'
          name={icon}
          backgroundColor={backgroundColor}
          color='textPrimary'
        />
        <Text variant='webBodySecondary' mr='xs'>
          {title}
        </Text>
      </Box>
    </TouchableOpacity>
  );
};
